const apis = {
  getDevList: {
    url: '/api/v1/devices',
    name: 'GET_MACH_LIST',
  },
};

export default apis;
